function obj2FormData(obj: Record<string, string | File>) {
  const formData = new FormData();
  Object.entries(obj).forEach(([key, value]) => {
    formData.append(key, value as string | File);
  });
  return formData;
}

export {
    obj2FormData,
};
